export const USER_TERMINAL_ID = 'userTerminalId';
export const USER_TERMINAL_CODE = 'userTerminalCode';
export const USER_LOCATION_CODE = 'userLocationCode';
export const TERMINAL_TYPE = {
  showroom: 'SHR',
};
